<template>
  <div class="register-partner">
    <div class="titulo">
      <h1>Quais são os dados da sua empresa?</h1>
      <p>Agora precisamos saber algumas informações sobre a sua empresa.</p>
    </div>

    <div class="card-box full">
      <form @submit="submitHandler" autocomplete="off">
        <div class="linha">
          <div class="eight">
            <label>Razão Social</label>
            <input type="text"
                   placeholder="Digite a razão social da empresa"
                   v-model="form.name"
                   maxlength="100"/>
          </div>
          <div class="eight">
            <label>Nome Fantasia</label>
            <input type="text"
                   placeholder="Digite o nome fantasia da empresa"
                   v-model="form.tradingName"
                   maxlength="100"/>
          </div>
        </div>
        <div class="linha">
          <div class="eight">
            <label>CNPJ</label>
            <the-mask :mask="MASK_CNPJ"
                      placeholder="Digite somente números"
                      v-model="form.document"/>
          </div>
          <div class="eight">
            <label>E-mail</label>
            <input type="text" placeholder="socio@email.com" v-model="form.email" maxlength="200"/>
          </div>
        </div>
        <div class="linha">
          <div class="eight">
            <label>Celular</label>
            <the-mask :mask="[MASK_PHONE_BR, MASK_PHONE_BR_ADG]"
                      placeholder="Digite somente números"
                      v-model="form.cellPhone"/>
          </div>
          <div class="eight">
            <label>Telefone</label>
            <the-mask :mask="MASK_PHONE_BR"
                      placeholder="Digite somente números"
                      v-model="form.phone"/>
          </div>
        </div>

        <div class="erroDados" v-if="form.document && !documentIsValid">
          O CNPJ é inválido.
        </div>

        <div class="erroDados" v-if="form.email && !emailIsValid">
          E-mail inválido.
        </div>

        <div class="erroDados" v-if="form.cellPhone && !cellPhoneIsValid">
          Celular inválido.
        </div>

        <div class="erroDados" v-if="documentState === STATE_NOT_AVAILABLE">
          Este CNPJ já está sendo usado por outro usuário.
        </div>

        <ContinueSection enable-back :enable-continue="enableSubmit" @back="$emit('back')"/>
      </form>
    </div>
  </div>
</template>

<script>
import isValidCnpj from '@brazilian-utils/is-valid-cnpj'
import isValidPhone from '@brazilian-utils/is-valid-phone'
import isValidEmail from '@/common/utils/isValidEmail'
import Info from '../components/Info'
import CheckBox from '../components/CheckBox'
import ContinueSection from '../components/ContinueSection'
import { verifyDocument } from '@/common/lib/api'

const STATE_CHECKING = 'CHECKING'
const STATE_AVAILABLE = 'AVAILABLE'
const STATE_NOT_AVAILABLE = 'NOT_AVAILABLE'

let documentTimeoutID = null

export default {
  name: 'RegisterJuridical',
  components: {
    ContinueSection,
    CheckBox,
    Info
  },
  model: {
    prop: 'company',
    event: 'submit'
  },
  props: {
    company: Object
  },
  data: () => ({
    STATE_NOT_AVAILABLE,
    documentState: STATE_AVAILABLE,
    form: {
      name: '',
      tradingName: '',
      document: '',
      email: '',
      phone: '',
      cellPhone: ''
    }
  }),
  methods: {
    submitHandler(e) {
      e.preventDefault()

      this.$emit('submit', this.form)

      return false
    }
  },
  computed: {
    enableSubmit() {
      const {
        form, documentIsValid, emailIsValid, cellPhoneIsValid, documentState
      } = this

      const {
        name, document, email, cellPhone
      } = form

      return !!(
        name
        && email
        && document
        && cellPhone
        && emailIsValid
        && documentIsValid
        && cellPhoneIsValid
        && documentState === STATE_AVAILABLE
      )
    },
    documentIsValid() {
      return isValidCnpj(this.form.document)
    },
    emailIsValid() {
      return isValidEmail(this.form.email)
    },
    cellPhoneIsValid() {
      return isValidPhone(this.form.cellPhone)
    }
  },
  watch: {
    company(company) {
      this.form = company
    },
    'form.document': function (document) {
      this.documentState = STATE_CHECKING
      clearTimeout(documentTimeoutID)

      if (!this.documentIsValid) {
        this.documentState = STATE_AVAILABLE
        return
      }

      documentTimeoutID = setTimeout(async () => {
        this.documentState = await verifyDocument(document)
          ? STATE_AVAILABLE
          : STATE_NOT_AVAILABLE
      }, 500)
    }
  },
  mounted() {
    this.form = this.company
  }
}
</script>
